import React, { useState } from 'react';
import axios from 'axios';

const Payment = ({ userId, serviceCost }) => {
  const [paymentAddress, setPaymentAddress] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [statusMessage, setStatusMessage] = useState('');

  const startPayment = async () => {
    setLoading(true);
    setError('');
    try {

      const response = await axios.post('/api/payment/start', { userId, serviceCost });
      setPaymentAddress(response.data.address);
    } catch (err) {
      setError('Error al iniciar el pago. Intenta de nuevo.');
    } finally {
      setLoading(false);
    }
  };


  const checkPaymentStatus = async () => {
    setLoading(true);
    try {

      const response = await axios.get(`/api/payment/status?userId=${userId}`);
      if (response.data.success) {
        setStatusMessage('¡Pago confirmado!');
      } else {
        setStatusMessage('Pago no confirmado. Verifica de nuevo más tarde.');
      }
    } catch (err) {
      setError('Error al verificar el estado del pago.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h2>Pago de Servicio</h2>
      {error && <div className="error">{error}</div>}
      {!paymentAddress && (
        <button onClick={startPayment} disabled={loading}>
          {loading ? 'Generando dirección...' : 'Iniciar Pago'}
        </button>
      )}
      {paymentAddress && (
        <div>
          <p>Envía el pago a la siguiente dirección:</p>
          <pre>{paymentAddress}</pre>
          <button onClick={checkPaymentStatus} disabled={loading}>
            {loading ? 'Verificando estado...' : 'Verificar Estado del Pago'}
          </button>
        </div>
      )}
      {statusMessage && <div>{statusMessage}</div>}
    </div>
  );
};

export default Payment;
